// src/i18n/en/auth.js
const auth = {
    login: {
        title: 'Sign In',
        subtitle: 'Locker Management System',
        username: 'Email',
        password: 'Password',
        sign_in: 'Sign In',
        remember_me: 'Remember me',
        forgot_password: 'Forgot your password?',
        error: 'Incorrect username or password',
        loading: 'Signing in...',
    },
    logout: {
        title: 'Sign Out',
        message: 'Are you sure you want to sign out?',
        confirm: 'Sign out',
        cancel: 'Cancel',
    },
    errors: {
        invalid_credentials: 'Invalid credentials',
        session_expired: 'Your session has expired',
        unauthorized: 'You do not have permission to access this resource',
        forbidden: 'Access denied',
        network_error: 'Connection error',
    },
    password: {
        change_title: 'Change Password',
        reset_title: 'Reset Password',
        current: 'Current password',
        new: 'New password',
        confirm: 'Confirm new password',
        requirements: {
            title: 'Password must have:',
            minLength: 'At least 8 characters',
            uppercase: 'An uppercase letter',
            lowercase: 'A lowercase letter',
            number: 'A number',
            special: 'A special character (!@#$%^&*)',
        },
        errors: {
            mismatch: 'Passwords do not match',
            weak: 'Password is too weak',
            same: 'New password must be different from the current one',
        },
        success: 'Password updated successfully',
    },
    profile: {
        title: 'My Profile',
        edit: 'Edit profile',
        change_password: 'Change password',
        logout: 'Sign out',
        role: 'Role',
        hotel: 'Hotel',
        group: 'Group',
        last_login: 'Last login',
    },
    roles: {
        SuperAdmin: 'Super Administrator',
        GroupAdmin: 'Group Administrator',
        HotelAdmin: 'Hotel Administrator',
        Receptionist: 'Receptionist',
        User: 'User',
    },
    session_expiry: {
        title: 'Session about to expire',
        message: 'Your session will expire in {time}. Do you want to extend it?',
        time_remaining: 'Time remaining',
        extend: 'Extend session',
        info: 'For security, sessions expire after a period of inactivity. You can extend your session or log out now.',
    },
};

export default auth;
